import { useMemo } from "react";
import { useParams } from "react-router";
import { defineMessages, useIntl } from "react-intl";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { IconChevronLeft } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { LocaleLink, useLocaleContext } from "@ct-react/locale";
import { CmsPageContent, extractCmsContent } from "@shared/graphql";
import { article } from "../../i18n/sharable-defs";
import { Wrapper } from "../../components/layout/wrapper";
import SeoMetas from "../../components/layout/seo-metas";
import PageHero from "../../components/layout/page-elements/page-hero";
import "./item.scss";

const transDefs = defineMessages({
  back: { id: "news.item.back", defaultMessage: "Revenir à l'actualités" }
});

const SINGLE_NEWS_PAGE_GQL_DATA = gql`
  query SingleNewsPage($pageId: ID!) {
    cms: cmsPage(pageId: $pageId) { createdAt data }
  }
`;

const NewsItemPage = () => {

  const intl = useIntl();
  const { locale } = useLocaleContext();
  const { id: pageId } = useParams();

  const { data, loading } = useQuery<{ cms: any }>(SINGLE_NEWS_PAGE_GQL_DATA, {
    ssr: true,
    variables: { pageId }
  });

  const content = useMemo<CmsPageContent | undefined>(() => {
    if (!data?.cms) return undefined;
    return extractCmsContent(data.cms.data, locale);
  }, [ data, locale ]);

  const wrapperClasses = classNames("single-news-page");

  if (loading || !content)
    return (
      <main className={wrapperClasses}>
        <div className="wrap centered main-hero" />
      </main>);

  return (
    <main key={pageId} className={wrapperClasses}>

      <SeoMetas title={content.summary.title}
                description={content.summary.lead}
                image={content.summary.image.assets.find((asset: any) => asset.breakpoint === "LG")?.url} />
      <PageHero background={content.summary.image.originalUrl} />

      <Wrapper.Centered className="content">

        <LocaleLink to="/agency/news/" className="nav-link">
          <IconChevronLeft className="n-icon" />
          {intl.formatMessage(transDefs.back)}
        </LocaleLink>

        <span className="published">
          {intl.formatMessage(article.published, {
            date: intl.formatDate(data!.cms.createdAt, { dateStyle: "medium", timeStyle: "short" })
          })}
        </span>
        <h1>{content.summary.title}</h1>
        {!!content.summary.lead &&
          <p className="lead">{content.summary.lead}</p>
        }
        <div className="html-format" dangerouslySetInnerHTML={{ __html: content.content }} />
      </Wrapper.Centered>

    </main>);

}

export default NewsItemPage;
